module.exports = __webpack_public_path__ + "img/abi.450f622e.png";